import React, { useState, useEffect } from "react";
import { Row, Col, Form, Spinner, Modal, Button } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import "../../Styles/yellowcalf.css/Failed_Transactions.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";

function ParentTransactionReceipt() {
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [idSearch, setIdSearch] = useState("");
  const [selectedInvoices, setSelectedInvoices] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;


  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
const [totalPages, setTotalPages] = useState(1); 
  const navigate = useNavigate();


  // Toggle single checkbox
const handleRowCheck = (feeInvoiceId) => {
  setSelectedInvoices((prev) =>
    prev.includes(feeInvoiceId)
      ? prev.filter((id) => id !== feeInvoiceId)
      : [...prev, feeInvoiceId]
  );
};

// Header "Check All"
const handleCheckAll = (checked) => {
  if (checked) {
    const allIds = transactionList.map(
      (item) => item.fee_invoice_id
    );
    setSelectedInvoices(allIds);
  } else {
    setSelectedInvoices([]);
  }
};

useEffect(() => {
  const handler = setTimeout(() => {
    fetchFailedTransactions();
  }, 500);

  return () => {
    clearTimeout(handler);
  };
}, [currentPage, idSearch, searchTerm]);

  const fetchFailedTransactions = async () => {
    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") ||
          "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        status: "success",
        page: currentPage,
      };
      if(idSearch) {
        payload.parent_transactions_id  = idSearch
      }
      if(searchTerm) {
        payload.student_name  = searchTerm
      }

      const response = await simplePostCall(
        ApiConfig.parentfailedtransaction,
        JSON.stringify(payload)
      );

      if (response?.result) {
        setTransactionList(response.searchModel || []);
        setTotalPages(response?.total_pages)
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };




  return (
    <div className="container-fluid py-4">
      {/* HEADER */}
      <div className="bg-white p-3 rounded shadow-sm mb-3 d-flex justify-content-between">
        <h5 className="mb-0 fw-bold ">
          Parent Successful Transactions
        </h5>
        <Button className="btn-ft" size="sm">Print All</Button>
      </div>

      {/* FILTER BAR */}
      <div className="bg-white p-3 rounded shadow-sm mb-3">
        <Row className="g-2 align-items-center">
          {/* <Col md={2}>
            <Form.Select>
              <option>Paid By User</option>
              <option>Accountant Account</option>
            </Form.Select>
          </Col> */}

          <Col md={2}>
            <Form.Control
              placeholder="Student Name"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </Col>

          {/* <Col md={1}>
            <Form.Select>
              <option>Grade</option>
            </Form.Select>
          </Col> */}

          {/* <Col md={1}>
            <Form.Select>
              <option>Division</option>
            </Form.Select>
          </Col> */}

          <Col md={2}>
            <Form.Control
              placeholder="Transaction Id"
              value={idSearch}
              onChange={(e) => {
                setIdSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </Col>

          {/* <Col md={2}>
            <Form.Select>
              <option>Transaction Mode</option>
            </Form.Select>
          </Col> */}

          <Col md={2}>
            <Button
              className="btn-ft w-100"
              onClick={() => {
                setSearchTerm("");
                setIdSearch("");
                setCurrentPage(1);
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </div>

    {/* TABLE */}
<div className="bg-white rounded shadow-sm">
  {/* TABLE HEADER */}
  <Row className="fw-bold text-muted small text-center py-3 border-bottom gx-0">
    <Col xs={1}>
   <Form.Check
  checked={
    transactionList.length > 0 &&
    selectedInvoices.length === transactionList.length
  }
  onChange={(e) => handleCheckAll(e.target.checked)}
/>
    </Col>
    <Col xs={2}>Paid By User</Col>
    <Col xs={2}>Student Name</Col>
    <Col xs={1}>Grade</Col>
    <Col xs={1}>Division</Col>
    <Col xs={2}>Transaction Id</Col>
    <Col xs={1}> Amount</Col>
    <Col xs={1}>Mode</Col>
    <Col xs={1}>Actions</Col>
  </Row>

  {/* TABLE BODY */}
  {isLoading ? (
    <div className="text-center p-3">
      <ScaleLoader color="#F4BB44" />
    </div>
  ) : transactionList?.length > 0 ? (
    transactionList?.map((item, index) => (
      <Row
        key={item.parent_transactions_id}
        className="text-center align-items-center small py-3 border-bottom gx-0"
      >
        <Col xs={1}>
         <Form.Check
  checked={selectedInvoices.includes(item.fee_invoice_id)}
  onChange={() => handleRowCheck(item.fee_invoice_id)}
/>
        </Col>

        <Col xs={2}>Accountant Account</Col>

        <Col xs={2} className="fw-bold text-truncate">
          {item.student_name}
        </Col>

        <Col xs={1}>{item.student_class}</Col>

        <Col xs={1}>{item.division || "-"}</Col>

        <Col xs={2}>{item.parent_transactions_id}</Col>

        <Col xs={1}>${item.transaction_amount}</Col>

        <Col xs={1}>{item.transaction_mode}</Col>

        <Col xs={1}>
          <div className="d-flex justify-content-center gap-2">
            <FaEye
              title="View"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/accountant/parenttransactions/view/${item.parent_transactions_id}`
                )
              }
            />
           
          </div>
        </Col>
      </Row>
    ))
  ) : (
    <div className="text-center py-4">No records found</div>
  )}
</div>


      {/* PAGINATION */}
      <div className="d-flex justify-content-end align-items-center mt-3 gap-2">
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </Button>

        <span className="small">
          Page {currentPage} of {totalPages || 1}
        </span>

        <Button
          size="sm"
          variant="outline-secondary"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </Button>
      </div>

  
    </div>
  );
}

export default ParentTransactionReceipt;
